module.exports = __webpack_public_path__ + "img/logo-gris.13c4616d.png";